<script setup>
const props = defineProps({
    color: {
        type: String,
        required: true,
        default: 'transparent'
    },
    background: {
        type: String,
        required: false,
        default: 'white'
    },
    itemTotal: {
        type: Number,
        required: true
    },
    activeIndex: {
        type: Number,
        required: true
    },
});

const emit = defineEmits(['updateIndex']);

function handleClick(e) {
    emit('updateIndex', parseInt(e.currentTarget.getAttribute('data-index'), 10));
}
</script>

<template>
    <section class="dot-controls" :style="`--fill-color: ${color}; --background-color: ${background}`">
        <button v-for="(item, index) in itemTotal" :key="index" class="dot-button"
            :aria-label="`Go to slide ${index + 1} of ${itemTotal}`"
            :class="{ active: index === activeIndex }" @click="handleClick" :data-index="index">
            <MessSvg type="CarouselDot" />
        </button>
    </section>
</template>

<style lang="scss">
.dot-controls {

    display: flex;
    gap: 12px;

    .dot-button {
        width: 12px;
        height: 12px;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        align-items: center;
        fill: var(--background-color);
        color: transparent;
        transition: all 0.3s ease-in-out;

        scrollbar-width: none;
        -ms-overflow-style: none;

        &::-webkit-scrollbar {
            display: none; /* For Chrome, Safari, and Opera */
        }

        &.active {
            fill: var(--fill-color);
        }
    }
}
</style>
